// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__36jb0","col":"styles_col__24372","fulfillmentStatus":"styles_fulfillmentStatus__VTKEh","emailCol":"styles_emailCol__3fpdh"};